"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDates = void 0;
const dateISORegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIsoDateString = (value) => value && typeof value === 'string' && dateISORegex.test(value);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleDates = (body) => {
    if (body === null || body === undefined || typeof body !== 'object') {
        return;
    }
    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value)) {
            // eslint-disable-next-line no-param-reassign
            body[key] = new Date(value);
        }
        else if (typeof value === 'object') {
            (0, exports.handleDates)(value);
        }
    }
};
exports.handleDates = handleDates;
